<template>
    <div class="album albumvideo">
        <div>
            <div class="upload-avatar">
                <div class="avatar-item" v-for="(imageItem, imageIndex) in data" :key="imageIndex">
                    <video :src="imageItem" class="avatar video-avatar" :controls="false">您的浏览器不支持视频播放
                    </video>
                    <span class="upload-list__item-actions">
                <el-popover
                        placement="right"
                        width="600"
                        trigger="click">
                 <video :src="imageItem" controls="controls">您的浏览器不支持音频播放</video>
              <span class="upload-list__item-preview" slot="reference">
            <el-icon class="el-icon-video-play"></el-icon>
            </span>
</el-popover>
            <span class="upload-list__item-delete" @click.stop="reMainVip(imageIndex)">
              <el-icon class="el-icon-delete"></el-icon>
            </span>
          </span>
                </div>
            </div>
            <div class="pic_img">
                <div class="pic_img_box" style="display: flex;">
                    <el-upload
                            v-if="data.length < max"
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :data="uploadData"
                            :on-progress="uploadVideoProcess"
                            :on-success="function(response, file,flList){
                            skuImg(response,file,flList)
                  }"
                            :before-upload="beforeUploadVideo"
                            :show-file-list="false"
                            :file-list="data"
                            accept="video/mp4,video/ogg,video/x-flv,video/avi,video/x-msvideo,video/x-ms-wmv,video/quicktime,.mp4,.ogg,.flv,.avi,.wmv,.rmvb,.mov"
                    >
                        <i class="el-icon-plus"></i>
                        <el-progress
                                v-if="videoFlag == true"
                                type="circle"
                                v-bind:percentage="videoUploadPercent"
                                style="margin-top:7px;"
                        ></el-progress>
                        <div slot="tip" class="el-upload__tip">
                            <span>视频要求</span>
                            <span v-for="(vv, ii) in text" :key="ii">{{ ii + 1 }}.{{ vv }}</span>
                            <span>{{ text.length + 1 }}.最多上传{{ max }}个</span>
                        </div>
                    </el-upload>
                </div>
            </div>
        </div>
        <select-file :value="data" :size="max" :file-type="3" @change="fileChanged"></select-file>
    </div>
</template>
<script>
import { getToken } from '@/api/demo/classification/index'
import Video from '@/pages/demo/configuration/templateDialog/video'
// import selectFile from "@/components/file/selectFile.vue";

export default {
  components: {
    selectFile: () => import('@/components/file/selectFile.vue'),
    Video
  },
  name: 'uploadVideo',
  model: {
    prop: 'filterManage',
    event: 'change'
  },
  props: {
    max: {
      type: Number,
      default: 1
    },
    filterManage: {
      type: Array | String,
      default: () => []
    },
    text: {
      type: Array,
      default: () => ['视频大小500MB以内', '视频格式mp4/avi/mov']
    }
  },
  data () {
    return {
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      https: null,
      resHttps: [],
      videoFlag: false,
      // 是否显示进度条
      videoUploadPercent: '',
      // 进度条的进度，
      isShowUploadVideo: false
    }
  },
  created () {
    this.getTokened()
  },
  computed: {
    data () {
      if (this.max === 1) {
        return this.filterManage.length > 0 ? [this.filterManage] : []
      }
      return this.filterManage
    }
  },
  methods: {
    fileChanged (value) {
      if (this.max === 1) {
        this.data = [value]
      } else {
        this.data = value
      }
      this.$emit(
        'change',
        value
      )
    },
    getTokened () {
      let that = this
      getToken({}).then(res => {
        that.uploadData.token = res.token
        that.https = res.domain
      })
    },
    // 上传前回调
    beforeUploadVideo (file) {
      var fileSize = file.size / 1024 / 1024 < 500
      var fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov',
          // 浏览器为 .mov 文件返回的标准 MIME 类型。
          'video/quicktime'
        ].indexOf(file.type) === -1 &&
        ['.mp4', '.ogg', '.flv', '.avi', '.wmv', '.rmvb', '.mov'].indexOf(fileExtension) === -1
      ) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
      if (!fileSize) {
        this.$message.error('视频大小不能超过500MB')
        return false
      }
      this.uploadData.key = `_video_${new Date().getTime()}_${file.name}`
      this.isShowUploadVideo = false
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      console.log(file, 'filefilefilefilefilefile')
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    // 上传成功回调
    skuImg (res, file, flList) {
      let that = this
      that.isShowUploadVideo = true
      that.videoFlag = false
      that.videoUploadPercent = 0
      console.log('that.https + "/" + res.key', that.https + '/' + res.key)
      if (flList.length > that.max) {
        that.$message.info(`最大上传${that.max}个视频`)
        return
      }
      that.data.push(that.https + '/' + res.key)
      if (this.max === 1) {
        this.$emit(
          'change',
          this.data[0]
        )
      } else {
        this.$emit(
          'change',
          this.data.map(item => {
            return item
          })
        )
      }
    },
    reMainVip (index) {
      if (this.max === 1) {
        this.$emit(
          'change',
          ''
        )
      } else {
        this.$emit(
          'change',
          this.filterManage
            .filter((_, i) => i !== index)
            .map(item => {
              return item || item
            })
        )
      }
    }
  },
  mounted () {
    // console.log('typeof this.filterManage',this.filterManage)
    if (this.max === 1) {
      this.data = [this.filterManage]
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
.upload-avatar,
.zgu-upload {
  display: flex;
}

.el-upload__tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  line-height: 16px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-item {
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  line-height: 100px;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  margin: 0 8px 8px 0;
  display: inline-block;
}

.upload-list__item-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s;

  &:hover {
    opacity: 1;
    cursor: pointer;
  }

  .upload-list__item-delete {
    margin-left: 15px;
  }
}
</style>
<style lang="scss">
.avatar-uploader {
  display: flex;
}

.el-upload {
  text-align: center;
  cursor: pointer;
  outline: 0;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #666;
}

.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
</style>
